import { observable, action, runInAction } from 'mobx'
import { json } from '../../../../utils/ajax'

class TechnicalBContent {

    @observable loading
    @observable years            //年份
    @observable catalog          //目录
    @observable list             //内容列表
    @observable carSeriesName    //车系名字
    @observable pagination       //分页
    @observable typeSelected     //选择的类型id
    @observable typeName         //选择的类型
    @observable catalogName      //选择的目录
    @observable year             //选择的年份
    @observable flag             //判断是否显示目录
    @observable catalogSelected  //选择的目录id
    @observable searchParam      //搜索框

    constructor () {
        this.loading = false;
        this.years = [];
        this.catalog = [];
        this.list = [];
        this.carSeriesName = '';
        this.pagination = [];
        this.flag = false;
        this.typeSelected = '';
        this.typeName = '';
        this.catalogSelected = '';
        this.year = '';
        this.catalogName = '';
        this.searchParam = '';
    }

    //初始化页面
    @action
    init = async(carSeriesId, type, directoryId, year) => {
        runInAction(()=>{
            this.loading = true;
            this.list = [];
        })

        const carSeries = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/carseriesCatalog/carseries/id/${carSeriesId}`)
        if(carSeries && carSeries.status === 0){
          runInAction(() => {
            this.loading = false;
          })
          return
        }
        runInAction(() => {
            this.carSeriesName = carSeries.carseriesName
            this.loading = false;
            this.year=year
            this.typeSelected=type
        })
        this.__getYears();
        await this.__findCatalog(carSeriesId);
        await this.getInitList(carSeriesId, type, directoryId, year);

    }
    //选择类型
    @action
    chooseType = async(id,carSeriesId,page) =>{
      runInAction(()=>{
        this.typeSelected = id;
      })
      if(id === '1'){
        runInAction(()=>{
          this.flag = false;
          this.typeName = '快讯';
          this.catalogSelected = '';
          this.catalogName = '';
          this.year = ''
        })
      }else{
        runInAction(()=>{
          this.flag = true;
          this.typeName = '简报';
          this.catalogSelected = ''
          this.catalogName = '';
          this.year = ''
        })
      }
      await this.getInitList(carSeriesId,this.typeSelected, this.catalogSelected, this.year,page);
    }
    //选择目录
    @action
    chooseCatalog = async(id,carSeriesId,page) =>{
      runInAction(()=>{
        this.loading = true;
      })
      for(let i = 0;i<this.catalog.length;i++){
        if(id === this.catalog[i].id){
          runInAction(()=>{
            this.catalogSelected = id;
            this.catalogName = this.catalog[i].defaultName;
          })
        }
      }
      await this.getInitList(carSeriesId,this.typeSelected, this.catalogSelected, this.year,page);
    }
    //选择年份
    chooseYear = async(year,carSeriesId,page) =>{
      runInAction(()=>{
        this.loading = true;
        this.year = year
      })
      await this.getInitList(carSeriesId,this.typeSelected, this.catalogSelected, this.year,page);
    }

    //请求内容列表
    @action
    getInitList = async(carSeriesId,type, directoryId, year, page) =>{
        const search = {}
        search['search.carSeriesId'] = carSeriesId;
        if (type !== 'none') {
          search['search.type'] = type
        }
        if (directoryId !== 'none') {
          search['search.catalogId'] = directoryId
        }
        if (year !== 'none') {
          search['search.createTime'] = year
        }
        if (this.searchParam !== 'none') {
          search['search.title'] = this.searchParam
        }
        runInAction(() => {
          this.loading = true
          this.carSeriesId = carSeriesId
        })
        if (page) {
          page--
        } else if (this.pagination.page) {
          page = this.pagination.page - 1
        } else {
          page = 0
        }
        search.page = page
        search['search.approval'] = 5
        const list = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontents:parse`, search)
        if(list && list.status === 0){
          return
        }
        runInAction(()=>{
          this.list = list.content;
          this.loading = false;
          this.pagination = {
            total: list.totalElements,
            results: list.size,
            page: list.number + 1,
          }
      })
    }

    //请求目录
    __findCatalog = async (carSeriesId) => {
      runInAction(() => {
        this.loading = true
        this.carSeriesId = carSeriesId
      })
      const catalog = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/list?carseriesId=`+carSeriesId);
      if(catalog && catalog.status === 0){
        return
      }
      runInAction(()=>{
        this.catalog = catalog;
        this.loading = false;
      })
    }
    //获取年份
    __getYears = () => {
      let arr = [];
      let date = new Date();
      let endYear = date.getFullYear();// 获取当前年份
      for (let i = endYear; i >= endYear-9; i--) {
        arr.push({
          year: i
        });
      }
      runInAction(()=>{
        this.years = arr;
      })
    }
    @action initSearchParam=(searchParam)=>{
      runInAction(()=>{
        this.searchParam=searchParam
      })

    }

}

export default new TechnicalBContent()


// WEBPACK FOOTER //
// ./src/project/dongfeng/technicalBriefing/TBContent/store.js